module.exports = __webpack_public_path__ + "img/section-3-content_3_img.17a3a74a.png";